@for (item of filters; track item) {
  <button
    class="bdo-tab-button re-mr-10"
    [ngClass]="{'md:re-mr-20' : item.title, 're-mr-20' : !item.iconSrc}"
    [class.active]="item.id === selected"
    [title]="item.title || item.id"
    (click)="onSelect(item.id)"
    >
    <div [ngClass]="{'md:re-p-5 md:re-pr-10' : item.iconSrc && item.title}"
      [class.re-p-10]="item.iconSrc">
      @if (item.iconSrc) {
        <svg-icon
          class="icon re-w-25 re-h-25 re-inline-block"
          [ngClass]="{'md:re-mr-5' : item.title}"
          [applyClass]="true"
          [src]="item.iconSrc"
        ></svg-icon>
      }
      @if (item.title) {
        <div
          class="re-inline-block re-leading-m"
          [ngClass]="{'re-hidden md:re-inline-block md:re-pr-10' : item.iconSrc}"
          >
          {{item.title}}
        </div>
      }
    </div>
  </button>
}
